import { resolvePushAttention, type PushAttentionReason } from './pushAttention';
import type { WebPushState } from './webPushState';

/**
 * Спрашивать ли разрешение на уведомления в вебе, и по какому поводу.
 *
 * Здесь и только здесь решается, занимать ли человеку экран. Три условия, каждое своей ценой:
 *
 * 1. Повод был. `armed` поднимается после действия, ради которого уведомления и нужны:
 *    отправил сообщение, создал заявку, откликнулся, вошёл в сессию. До этого мы для человека
 *    сайт, который просит непонятно чего, а отказ в Chrome это настройка сайта навсегда.
 * 2. Состояние ровно `prompt`. Сужение делается ЗДЕСЬ, до общего движка отката: слово `prompt`
 *    состоит в обоих словарях, и в `WebPushState`, и в `PushAttentionReason`, поэтому
 *    дальше всё сходится без приведения типов и без расширения нативного `NativePushState`.
 *    По этой же причине `pushAttention.ts` в этой правке не меняется ни на строку, и ни один
 *    нативный путь не может сломаться.
 * 3. Срок отката вышел. Считает `resolvePushAttention`: неделя после «Не сейчас»
 *    (`PUSH_ATTENTION_BACKOFF_MS.prompt`), отметка из будущего при уехавших часах читается как
 *    «не спрашивали». Числа живут там и здесь не дублируются.
 *
 * Состояние `denied` поводом не является. Переспросить браузерным диалогом его нельзя (в
 * `usePushNotifications` эта ветка не делает ничего), а карточка «вы нас заблокировали» после
 * отправленного сообщения это прерывание с неизмеренной отдачей. Кто пойдёт разбираться, найдёт
 * объяснение в настройках профиля, у баннера `BrowserPushStatus`.
 */
export const resolveWebPushAsk = ({
  state,
  armed,
  askedAt,
  now,
}: {
  state: WebPushState;
  armed: boolean;
  askedAt: number | null;
  now: number;
}): PushAttentionReason | null => {
  if (!armed) {
    return null;
  }
  if (state !== 'prompt') {
    return null;
  }

  return resolvePushAttention({ state, askedAt, now });
};
